import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "small" }
const _hoisted_2 = { class: "list cvr-list-table" }
const _hoisted_3 = {
  key: 0,
  class: "not-searched"
}
const _hoisted_4 = { class: "list table-scrollbar" }

import { CVR_UPLOADS_HEADER, SELECTABLE_UPLOAD_STATUSES } from "@/services/consts/cvr_upload"
import HeaderComponent from "@/components/CvrConvert/HeaderComponent.vue"
import Row from "@/components/CvrConvert/CvrUploadListRow.vue";
import { ref, Ref, computed } from 'vue'
import i18n from '@/lang/i18n';
import getAccountResponse from "@/types/responses/getAccount"
import CvrUpload from "@/types/CvrUpload";

type selectableItemType = {
  id: string | number;
  key: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CvrUploadList',
  props: {
    items: {},
    showFlash: { type: Function },
    reload: { type: Function },
    listLoading: { type: Boolean },
    accounts: {},
    updateAuthority: { type: Boolean },
    modelValue: {},
    isManagementOffice: { type: Boolean }
  },
  emits: ['update:modelValue', 'search'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props;

const expandRowId: Ref<number | null> = ref(null);
const searchWindowStatus: Ref<boolean> = ref(false);
const selectableItems: Ref<{[key: string]: selectableItemType[]}> = ref({
  status: SELECTABLE_UPLOAD_STATUSES
})

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

function setExpandRowId(id: number) {
  if (expandRowId.value == id) {
    expandRowId.value = null
  } else {
    expandRowId.value = id
  }
}

function filterList() {
  searchWindowStatus.value = false
  emits("search");
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.cvr_uploads.holdMessages.noticeMessage')), 1),
    _createElementVNode("div", _hoisted_2, [
      (__props.listLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_table, null, {
          default: _withCtx(() => [
            _createVNode(HeaderComponent, {
              modelValue: modelValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
              headerLabels: _unref(CVR_UPLOADS_HEADER),
              items: selectableItems.value,
              onSearch: filterList
            }, null, 8, ["modelValue", "headerLabels", "items"]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
                return (_openBlock(), _createBlock(Row, {
                  key: 'cvr_uploads_' + item?.id,
                  item: item,
                  showFlash: props.showFlash,
                  expandRowId: expandRowId.value,
                  setExpandRowId: setExpandRowId,
                  reload: props.reload,
                  accounts: props.accounts,
                  updateAuthority: props.updateAuthority,
                  isManagementOffice: props.isManagementOffice
                }, null, 8, ["item", "showFlash", "expandRowId", "reload", "accounts", "updateAuthority", "isManagementOffice"]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})